import React from 'react';

import styled from 'styled-components';

import { IconHeart } from 'components/icons/heart';
import { IconHeartContoured } from 'components/icons/heart-contoured';

export const FavIconActive = styled(IconHeart)`
  fill: ${p => p.theme.token('icon-heart-favorite')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block-end: 1rem;
`;

export const FavIconInActive = styled(IconHeartContoured)`
  fill: ${p => p.theme.token('icon-heart-unfavorite')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block-end: 1rem;
`;

export const FavouriteIconWrapper = styled.div`
  padding: 0.125rem;
`;

export const FavouriteLoadingWrapper = styled.div`
  position: relative;
  inset-block-start: -0.25rem;
  inset-inline-start: -0.25rem;
`;

export const FavoriteIcon: React.FC<{ isFavorite: boolean }> = ({ isFavorite }) => {
  return isFavorite ? <FavIconActive /> : <FavIconInActive />;
};
